import React from "react";
import { Output } from "../Text";
import {
  Button,
  ButtonContainer,
  ContentSection,
  PageWrap,
  Heading,
} from "@vwfs-bronson/bronson-react";
import { RouteComponentProps } from "react-router-dom";
import { Analytics } from "../services/analytics";
import { setActualPage } from "../pages/page.utils";

enum ErrorCode {
  Default = "Default",
  AdditionalAppFormSubmit = "AdditionalAppFormSubmit",
  ApplicationFailed = "ApplicationFailed",
  ApplicationResultError = "ApplicationResultError",
  ApplicationResultInvalid = "ApplicationResultInvalid",
  BasicAppFormSavePersonalDetails = "BasicAppFormSavePersonalDetails",
  BasicAppFormSaveContactDetails = "BasicAppFormSaveContactDetails",
  BasicAppFormSave = "BasicAppFormSave",
  CalculationError = "CalculationError",
  CreditCheckError = "CreditCheckError",
  DacError = "DacError",
  ErrorGettingJourneyData = "ErrorGettingJourneyData",
  FullApplicationFormDocumentUploadError = "FullApplicationFormDocumentUploadError",
  FullApplicationFormSaveContactDetails = "FullApplicationFormSaveContactDetails",
  FullApplicationFormSaveEmploymentDetails = "FullApplicationFormSaveEmploymentDetails",
  FullApplicationFormSaveExpenditureDetails = "FullApplicationFormSaveExpenditureDetails",
  FullApplicationFormSavePaymentDetails = "FullApplicationFormSavePaymentDetails",
  FullApplicationFormSavePersonalDetails = "FullApplicationFormSavePersonalDetails",
  FullApplicationStartError = "FullApplicationStartError",
  HealthCheckError = "HealthCheckError",
  IdentificationPendingError = "IdentificationPendingError",
  ItemNotFound = "ItemNotFound",
  MissingIdentificationId = "MissingIdentificationId",
  MissingIdParameter = "MissingIdParameter",
  MissingJourneyData = "MissingJourneyData",
  PageNotFound = "PageNotFound",
  WebCalcError = "WebCalcError",
}

interface ErrorInformationProps {
  errorCode: string;
  routeProps: RouteComponentProps;
  entryPointUrl: string;
  errorMessage: string;
}

class ErrorInformation extends React.Component<ErrorInformationProps> {
  static defaultProps = {
    errorCode: ErrorCode.Default,
    entryPointUrl: "",
    errorMessage: "Unknown error",
  };

  constructor(props: ErrorInformationProps) {
    super(props);

    this.state = {};
  }

  pageName = "Error page";

  defaultTrackingData = {
    [Analytics.keys.pageName()]: this.pageName,
    [Analytics.keys.viewChange()]: this.pageName,
    [Analytics.keys.errorCode()]: this.props.errorCode,
    [Analytics.keys.errorMessage()]: this.props.errorMessage,
    [Analytics.keys.errorCausingURL()]: this.props.entryPointUrl,
  };

  trackPage = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.eventType(0)]: "pageView",
        [Analytics.keys.eventAction(0)]: "Success",
      };
      Analytics.setTrackingData({ ...this.defaultTrackingData, ...pageData });
      Analytics.trackPage();
    }, 1000);
  };

  componentDidMount() {
    setActualPage(this.pageName);
    this.trackPage();
  }

  shouldComponentUpdate() {
    return true;
  }

  goBack = () => {
    console.log("go back action", this.props.routeProps);
    this.props.routeProps.history.goBack();
  };

  reloadJourney = (entryPointUrl?: string) => {
    if (entryPointUrl) {
      window.location.assign(entryPointUrl);
    } else {
      // Trying to build from transactionId
    }
  };

  contactSupport = () => {
    console.log("contact support action", this.props.routeProps);
  };

  render() {
    const entryPointUrl = this.props.entryPointUrl;
    return (
      <ContentSection>
        <PageWrap>
          <Heading level="2">{Output.resolve("pages.error.title")}</Heading>
          {Output.resolveAsMarkdown("pages.error.subTitle")}

          <ButtonContainer center>
            {entryPointUrl ? (
              <Button onClick={() => this.reloadJourney(entryPointUrl)}>
                {Output.resolve("pages.error.reloadDataButtonText")}
              </Button>
            ) : (
              <Button onClick={this.goBack}>
                {Output.resolve("pages.error.goBackAndTryAgainButtonText")}
              </Button>
            )}
          </ButtonContainer>

          <p style={{ color: "#fff" }}>Error Code: {this.props.errorCode}</p>
        </PageWrap>
      </ContentSection>
    );
  }
}

export { ErrorInformation, ErrorCode };
